import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import imgLogo from './DPMS_Form_Logo.png';
import rightLogo from './right_bar.jpg';
import AImage from './Section3Images/A.png';
import BImage from './Section3Images/B.png';
import CImage from './Section3Images/C.png';
import DImage from './Section3Images/D.png';
import EImage from './Section3Images/E.png';
import FImage from './Section3Images/F.png';
import { useAuth } from 'oidc-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import validator from "validator";

function NewMarkingApprovalForm() {
    const auth = useAuth();
    const [configJsonFile, setConfigJsonFile] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);
                const data = await response.json();
                setConfigJsonFile(data);
                console.log("Json file read from the Public folder completed:");
            } catch (error) {
                console.error('Error fetching Config JSON file data:', error);
            }
        }
        fetchData();
    }, []);

    // General info section dropdown values
    const RequestTypeDropDownVal = ['-- Select --', 'Prod. Part (supplier sourcing, quality, part rev) - provide PO No.', 'PWC Eng. (new part creation) - provide PO No.', 'PWC Eng. (SFI MUP, Class 2) - provide PWC contact', 'NPI Supplier SFI - provide ES No.', 'Side by side approval'];
    const RequestReqAppDropDownVal = ['-- Select --', 'No special marking required', 'MSC TEI', 'MSC Vendor code', 'Manufacture symbol instead of vendor code', 'MSC part rev. letter', 'MSC Omit Trademark logo (or in-line)', 'Other (please specify comment is section 4, item 3)'];

    const RequestTypeDropDownVals = RequestTypeDropDownVal.map((RequestTypeDropDownVal, key) => <option key={key} value={key + '#' + RequestTypeDropDownVal}>{RequestTypeDropDownVal}</option>);
    const RequestReqAppDropDownVals = RequestReqAppDropDownVal.map((RequestReqAppDropDownVal, key) => <option key={key} value={key + '#' + RequestReqAppDropDownVal}>{RequestReqAppDropDownVal}</option>);

    // Section 1 Marking & Traceablity Requirements
    const ApplicableMarkingSpecVal = ['-- Select --', 'CPW10/CPW920', 'ESR1386/CPW2011', 'PN17.50/CPW2012', 'ES9-6/CPW2013', 'Other (provide details in section 4, item 3)'];
    const MarkingMethodVal = ['-- Select --', 'ACID ETCH', 'BRAND', 'Integral', 'Dot peening', 'Laser (Shallow)', 'Laser (Intermediate)', 'Laser (Deep)', 'Part ident, with label', 'bag & Tag (Label)', 'Etching (Shallow)', 'Etching (Deep)', 'Vibropeen (Manual)', 'Vibropeen (Mechanical)', 'Engrave (Manual)', 'Ink', 'Pencil and Ink marker', 'Other (provided details in section 4, item 3)'];
    const DrawingTypeVal = ['-- Select --', 'PWC Drawing (BTP)', 'HS Drawing (BTP)', 'Coordinate Control Part (CPW 103, CPW 154)', 'Source Control Part (CPW 101, CPW 102, CPW 144)', 'Source Control Part (HS)', 'Other (provide details in section 4, item 3)'];
    const RegulatoryInspectionMarkingVal = ['-- Select --', 'PWC Trademark format 4(Logo)', 'PWC Trademark form 1(in-line)', 'EASA Regulatory Marking (CAG 2073H)', 'DQR Stamp (ENSIP parts only)', 'Other (provide details in section 4, item 3)'];
    const TracebilityRequirementsVal = ['-- Select --', 'Serial Number (SER)', 'Casting Serial Number', 'Unique Identifier (UI)', 'Heat Code Forging Serial Number (HFSN)', 'No traceability required by drawing'];
    const AdditionalTracebilityVal = ['-- Select --', 'N/A', 'Heat Code', 'Heat Code & Forging Serial Number'];

    const ApplicableMarkingSpecDropDownVals = ApplicableMarkingSpecVal.map((ApplicableMarkingSpecVal, key) => <option key={key} value={key + '#' + ApplicableMarkingSpecVal}>{ApplicableMarkingSpecVal}</option>);
    const DrawingTypeDropDownVals = DrawingTypeVal.map((DrawingTypeVal, key) => <option key={key} value={key + '#' + DrawingTypeVal}>{DrawingTypeVal}</option>);
    const RegulatoryInspectionMarkingDropDownVals = RegulatoryInspectionMarkingVal.map((RegulatoryInspectionMarkingVal, key) => <option key={key} value={key + '#' + RegulatoryInspectionMarkingVal}>{RegulatoryInspectionMarkingVal}</option>);
    const TracebilityRequirementsDropDownVals = TracebilityRequirementsVal.map((TracebilityRequirementsVal, key) => <option key={key} value={key + '#' + TracebilityRequirementsVal}>{TracebilityRequirementsVal}</option>);
    const AdditionalTracebilityDropDownVals = AdditionalTracebilityVal.map((AdditionalTracebilityVal, key) => <option key={key} value={key + '#' + AdditionalTracebilityVal}>{AdditionalTracebilityVal}</option>);

    // Section 2 2D Data Matrix
    const TwoDDataMatrixRequirmentVal = ['-- Select --', 'No 2D data matrix required by drawing', 'CPW920-0 (ATA 2000)', 'CPW920-1 (PWC for Minimum Space Condition)', 'CPW920-2 (UID-Military Format)', 'CPW920-3 (HFSN)', 'CPW920-6 (UID-Non Serilaized Part)', 'CPW920-7 (UID-HFSN Part)', 'CPW920-8 (UID With Part Number)', 'CPW920-9 Heat Code', 'Construct 1 (HS 15314)', 'Construct 2 (HS 15314)', 'Other (please specify in section 2, item 3)'];
    const TwoDDataMatrixRequirmentDropDownVals = TwoDDataMatrixRequirmentVal.map((TwoDDataMatrixRequirmentVal, key) => <option key={key} value={key + '#' + TwoDDataMatrixRequirmentVal}>{TwoDDataMatrixRequirmentVal}</option>);

    // Section 3 
    const SelectLablePartTraceabilityVal = ['-- Select --', 'A) SER NO. (SER only or with 2D CPW920-1)', 'B) USN NO. (SER + 2D other formats)', 'C) UI NO. (UI only or with 2D CPW920-1)', 'D) UI NO. (UI + 2D other formats)', 'E) LOT (No traceability requirement)', 'F) Not applicable'];
    const SelectLablePartTraceabilityDropDownVals = SelectLablePartTraceabilityVal.map((SelectLablePartTraceabilityVal, key) => <option key={key} value={key + '#' + SelectLablePartTraceabilityVal}>{SelectLablePartTraceabilityVal}</option>);

    // Section 4
    const Additional_Ident_Markingsdd1Val = ['-- Select --', 'Factory Number (FN)', 'General Tracking Number', 'Mating Number/Matched Set Number', 'Lot Number', 'Carburizing Batch Number', 'Nitriding Batch Number', 'Heat Number', 'Heat Treat Batch Number', 'Heat Number & Heat treat Batch Number', 'Melt Number', 'Melt Number & Heat Treat Batch Number', 'Country of Origin', 'Date of manufacturing', 'Date of man. + Country of Or.'];
    const Additional_Ident_MarkingsddlDropDownVals = Additional_Ident_Markingsdd1Val.map((Additional_Ident_Markingsdd1Val, key) => <option key={key} value={key + '#' + Additional_Ident_Markingsdd1Val}>{Additional_Ident_Markingsdd1Val}</option>);

    const Additional_Ident_Markingsdd1Val_2 = ['-- Select --', 'Factory Number (FN)', 'General Tracking Number', 'Mating Number/Matched Set Number', 'Lot Number', 'Carburizing Batch Number', 'Nitriding Batch Number', 'Heat Number', 'Heat Treat Batch Number', 'Heat Number & Heat treat Batch Number', 'Melt Number', 'Melt Number & Heat Treat Batch Number', 'Country of Origin', 'Date of manufacturing', 'Date of man. + Country of Or.'];
    const Additional_Ident_MarkingsddlDropDownVals_2 = Additional_Ident_Markingsdd1Val_2.map((Additional_Ident_Markingsdd1Val_2, key) => <option key={key} value={key + '#' + Additional_Ident_Markingsdd1Val_2}>{Additional_Ident_Markingsdd1Val_2}</option>);

    const Additional_Ident_Markingsdd1Val_3 = ['-- Select --', 'Factory Number (FN)', 'General Tracking Number', 'Mating Number/Matched Set Number', 'Lot Number', 'Carburizing Batch Number', 'Nitriding Batch Number', 'Heat Number', 'Heat Treat Batch Number', 'Heat Number & Heat treat Batch Number', 'Melt Number', 'Melt Number & Heat Treat Batch Number', 'Country of Origin', 'Date of manufacturing', 'Date of man. + Country of Or.'];
    const Additional_Ident_MarkingsddlDropDownVals_3 = Additional_Ident_Markingsdd1Val_3.map((Additional_Ident_Markingsdd1Val_3, key) => <option key={key} value={key + '#' + Additional_Ident_Markingsdd1Val_3}>{Additional_Ident_Markingsdd1Val_3}</option>);

    const Additional_Ident_Markingsdd1Val_4 = ['-- Select --', 'Factory Number (FN)', 'General Tracking Number', 'Mating Number/Matched Set Number', 'Lot Number', 'Carburizing Batch Number', 'Nitriding Batch Number', 'Heat Number', 'Heat Treat Batch Number', 'Heat Number & Heat treat Batch Number', 'Melt Number', 'Melt Number & Heat Treat Batch Number', 'Country of Origin', 'Date of manufacturing', 'Date of man. + Country of Or.'];
    const Additional_Ident_MarkingsddlDropDownVals_4 = Additional_Ident_Markingsdd1Val_4.map((Additional_Ident_Markingsdd1Val_4, key) => <option key={key} value={key + '#' + Additional_Ident_Markingsdd1Val_4}>{Additional_Ident_Markingsdd1Val_4}</option>);



    const navigate = useNavigate();
    const [apimessage, setAPIMessage] = useState('');
    const [modelPopupshow, setmodelPopupshow] = useState(false);
    const [selectedFile, setSelectedFile] = useState([]);

    // Vendor Information section fields

    const [VendorCode, setVendorCode] = useState("");
    const [VendorName, setVendorName] = useState("");
    const [VendorEmail, setVendorEmail] = useState("");
    const [VendorContactName, setVendorContactName] = useState("");
    const [Telephone, setTelephone] = useState("");
    const [DateValue, setDateValue] = useState(new Date().toISOString().split('T')[0]);
    const [SupplierComments1, setSupplierComments1] = useState("");
    const [InitiatorEmailAddress, setInitiatorEmailAddress] = useState("");
    const [initiatorEmailError, setInitiatorEmailError] = useState("");
    const [vendorEmailError, setVendorEmailError] = useState("");

    // General Information section fields
    const [RequestType, setRequestType] = useState("");
    const [ES_PO_Contact, setES_PO_Contact] = useState("");
    const [PWC_PO_Holder_VendorCode, setPWC_PO_Holder_VendorCode] = useState("");
    const [Request_requiring_special_approval, setRequest_requiring_special_approval] = useState("");
    const [PN_Exception_Agreement, setPN_Exception_Agreement] = useState("");
    const [showPNExceptionCommentsText, setShowPNExceptionCommentsText] = useState(false);
    const [OtherPNExceptionComments, setOtherPNExceptionComments] = useState("");

    // Section 1 MARKING AND TRACEABILITY REQUIREMENTS
    const [For_A_PartNumber, setFor_A_PartNumber] = useState("");
    const [Part_Revision, setPart_Revision] = useState("");
    const [For_a_PNFamilyAndSufixes, setFor_a_PNFamilyAndSufixes] = useState("");
    const [ManufacturingSupplierPrefix, setManufacturingSupplierPrefix] = useState("");
    const [ApplicableMarkingSpec, setApplicableMarkingSpec] = useState("");
    const [ApplicableMarkingSpecTech, setApplicableMarkingSpecTech] = useState("");
    const [MarkingMethod, setMarkingMethod] = useState("");
    const [DrawingType, setDrawingType] = useState("");
    const [RegulatoryInspection, setRegulatoryInspection] = useState("");
    const [TracebilityRequirement, setTracebilityRequirement] = useState("");
    const [AdditionalTracebility, setAdditionalTracebility] = useState("");

    // Section 2 2D DataMatrix
    const [TwoDDataMatrixRequirment, setTwoDDataMatrixRequirment] = useState("");
    const [TwoDDataMatrixEncodedData, setTwoDDataMatrixEncodedData] = useState("");
    const [IfOtherPleaseSecify, setIfOtherPleaseSecify] = useState("");
    const [Other2DEncodedData, setOther2DEncodedData] = useState("");

    // Section 3 - CPW40 internal bar code Packaging label
    const [SelectLablePartTraceability, setSelectLablePartTraceability] = useState("");
    const [ShowSection3_A_Image, setShowSection3_A_Image] = useState(false);
    const [ShowSection3_B_Image, setShowSection3_B_Image] = useState(false);
    const [ShowSection3_C_Image, setShowSection3_C_Image] = useState(false);
    const [ShowSection3_D_Image, setShowSection3_D_Image] = useState(false);
    const [ShowSection3_E_Image, setShowSection3_E_Image] = useState(false);
    const [ShowSection3_F_Image, setShowSection3_F_Image] = useState(false);

    // Section 4 - HUMAN READABLE MARKING
    const [ProposedMarking, setProposedMarking] = useState("");
    const [Additional_Ident_Markings1ddl, setAdditional_Ident_Markings1ddl] = useState("");
    const [Additional_Ident_Markings1txt, setAdditional_Ident_Markings1txt] = useState("");
    const [AdditionalTxt_Required_1, setAdditionalTxt_Required_1] = useState(false);

    const [Additional_Ident_Markings2ddl, setAdditional_Ident_Markings2ddl] = useState("");
    const [Additional_Ident_Markings2txt, setAdditional_Ident_Markings2txt] = useState("");
    const [AdditionalTxt_Required_2, setAdditionalTxt_Required_2] = useState(false);

    const [Additional_Ident_Markings3ddl, setAdditional_Ident_Markings3ddl] = useState("");
    const [Additional_Ident_Markings3txt, setAdditional_Ident_Markings3txt] = useState("");
    const [AdditionalTxt_Required_3, setAdditionalTxt_Required_3] = useState(false);

    const [Additional_Ident_Markings4ddl, setAdditional_Ident_Markings4ddl] = useState("");
    const [Additional_Ident_Markings4txt, setAdditional_Ident_Markings4txt] = useState("");
    const [AdditionalTxt_Required_4, setAdditionalTxt_Required_4] = useState(false);

    const [Supplier_Ident_Marking_Explanation, setSupplier_Ident_Marking_Explanation] = useState("");
    const [apiErrormessage, setApiErrormessage] = useState("");
    const [invalidVendorCode, setInvalidVendorCode] = useState("");

    const [isConfirmChecked, setIsConfirmChecked] = useState(false);
    const csrfToken = useRef(null);
    const cookieToken = useRef(null);
    const [MarkingDropdownOptions, setMarkingDropdownOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const MarkingDrpoptions = {
        "1#CPW10/CPW920": ["ACID ETCH", "BRAND", "DOT PEENING", "DRAG IMPRESSION", "ELECTROLYTIC ETCH, DEEP", "ELECTROLYTIC ETCH, SHALLOW", "ENGRAVE, MANUAL", "ENGRAVE, MECHANICAL", "HOT STAMP", "INK", "INTEGRAL", "LABEL", "LAMINATED LABEL", "LASER, DEEP", "LASER, INTERMEDIATE", "LASER, SHALLOW", "METAL STAMP, DEBOSSING", "METAL STAMP, HAMMER", "METAL STAMP, PRESS", "METAL STAMP, ROLL", "PAINT", "PENCIL AND INK MARKERS", "VIBRATION PEEN, MANUAL", "VIBRATION PEEN, MECHANICAL"],
        "2#ESR1386/CPW2011": ["ACID ETCH", "CAST OR FORGED", "COMPUTER-CONTROLLED SHALLOW SCRIBE", "CONTAINER", "DECAL", "ELECTRIC ARC PENCIL", "ELECTRICAL OR ELECTRONIC PART INK", "ELECTRICAL WIRE MACHINE", "ELECTRO-CHEMICAL ETCH", "IMPRESSION", "LABEL", "LABELING (IN-HOUSE ONLY)", "LASER", "MACHINE", "MOLDED", "NAMEPLATE", "PROGRAMMABLE DOT MATRIX IMPACT PRINTING", "ROUTING", "RUBBER STAMP OR PEN INK", "SLEEVE/TAG/LABEL", "STENCIL", "TAG", "VIBROPEEN"],
        "3#PN17.50/CPW2012": ["ACID ETCH", "CAST OR FORGED", "COMPUTER-CONTROLLED SHALLOW SCRIBE", "DECALCOMANIA", "ELECTRIC ARC PENCIL", "ELECTRO-CHEMICAL", "IMPRESSION", "INK MARKING (ELECTRONIC PARTS)", "LABEL", "LABELING (IN-HOUSE ONLY)", "LASER", "MACHINE", "MACHINE MARKING ELECTRICAL WIRES", "MARKING CONTAINERS", "MOLDED", "PROGRAMMABLE DOT MATRIX IMPACT PRINTING", "RAYCHEM THERMOFITR (HIGH TEMPERATURE)", "RAYCHEM THERMOFITR (LOW TEMPERATURE)", "RAYCHEM TMS SYSTEM SIX", "ROUTING", "RUBBER STAMP AND PEN", "SILK-SCREEN", "STENCIL", "TAGGING", "VIBRA ETCHING"],
        "4#ES9-6/CPW2013": ["ELECTRO-CHEMICAL ETCH", "EMBOSSED/ENGRAVE (CASTING)", "ETCHING", "IDENT PLATE", "LASER ENGRAVING", "PLASTIC TAG", "PLASTIC/METAL STRIP", "RUBBER STAMP (PERMAMENT)", "RUBBER STAMP (TEMPORARY)", "RUBBER STAMPED TAG", "STEEL DIE STAMP", "STEEL DIE STAMPED TAG", "VIBROPEEN"],
        "5#Other (provide details in section 4, item 3)": ["OTHER (Provide details in section 4, item 3)"]
    };
    const ApplicableMarkingTechValues = {
        "1#CPW10/CPW920": "CPW10",
        "2#ESR1386/CPW2011": "ESR1386",
        "3#PN17.50/CPW2012": "PN17.50",
        "4#ES9-6/CPW2013": "ES9-6",
        "5#Other (provide details in section 4, item 3)": "Other"
    };

    let storedValue = localStorage.getItem("DPMSProcessID");
    let autoIncrementVal = "";
    let newProcessIDNum = "";

    const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
    }

    // Form submit 
    const handleSubmit = async (event) => {

        //Form Validation all required dropdown values selected
        const isFormValid = formValidation();
        const isEmailValid = formEmailValidation();
        if(TwoDDataMatrixRequirment =="1#No 2D data matrix required by drawing" || (TwoDDataMatrixRequirment !="1#No 2D data matrix required by drawing" && TwoDDataMatrixEncodedData!=""))
        {
        if (isFormValid && isEmailValid) {
            const isSubmitConfirm = window.confirm('Are you sure you want to submit this request?');
            if (isSubmitConfirm) {
                event.preventDefault();
                setLoading(true);
                var CurrentYear = getCurrentDateTime();
                if (storedValue == null) {
                    storedValue = 1;
                }

                // console.log("Auth User data Token: "+auth.userData.access_token);      
                var resTokenApiVal = auth.userData.access_token;

                // Call API Start
                newProcessIDNum = Number(storedValue) + 1;
                if (storedValue === 1) {
                    autoIncrementVal = String(storedValue).padStart(3, 0);
                }
                else {
                    autoIncrementVal = String(newProcessIDNum).padStart(3, 0);
                }
                const requestId = selectedFile.length;
                // Create JSON File
                //{ GUID: configJsonFile.DPMSGuids.VendorName, sValue: VendorName, name: "Vendor Name" },{ GUID: configJsonFile.DPMSGuids.Marking_Method, sValue: MarkingMethod, name: "MarkingMethod" },
                var PN_ExceptionVal = "";
                if (PN_Exception_Agreement) {
                    PN_ExceptionVal = "2#Yes";
                } else {
                    PN_ExceptionVal = "1#No"
                }
                var dictstring = {
                    ProcessInfo: {
                        domainId: "DPMSNewApprovalForm",
                        ProcessId: configJsonFile.NewDPMSProcessId,
                        NewRequest: true,
                        InstanceNumber: "",
                        AttachmentID: "Att_" + configJsonFile.NewDPMSProcessId + "_" + CurrentYear + "_" + autoIncrementVal + "_" + requestId,
                        PathID: configJsonFile.NewDPMSPathID,
                        workflowID: configJsonFile.DPMSGuids.WorkflowGuid,
                        businessEntity: configJsonFile.DPMSGuids.BusinessEntityGuid,
                        dbId: configJsonFile.DPMSGuids.dbId,
                        formTypeId: configJsonFile.DPMSGuids.formTypeId,
                        BaseBPSPortalAddress: configJsonFile.BaseBPSPortalAddress,
                        WebconClientId: configJsonFile.WebconClientId,
                        WebconclientSecret: configJsonFile.WebconclientSecret,
                        WebconTokenURL: configJsonFile.WebconTokenURL
                    },
                    Form: [
                        { GUID: configJsonFile.DPMSGuids.VendorCode, sValue: VendorCode + "#" + VendorCode, name: "Vendor Code" },
                        { GUID: configJsonFile.DPMSGuids.VendorEmail, sValue: VendorEmail, name: "Vendor Email" },
                        { GUID: configJsonFile.DPMSGuids.VendorName, sValue: VendorName, name: "Vendor Name" },
                        { GUID: configJsonFile.DPMSGuids.VendorContactName, sValue: VendorContactName, name: "Vendor Contact Name" },
                        { GUID: configJsonFile.DPMSGuids.Telephone, sValue: Telephone, name: "Telephone" },
                        { GUID: configJsonFile.DPMSGuids.SupplierComments, sValue: SupplierComments1, name: "Supplier Comments" },
                        { GUID: configJsonFile.DPMSGuids.RequestType, sValue: RequestType, name: "Request Type" },
                        { GUID: configJsonFile.DPMSGuids.ES_PO_Contact, sValue: ES_PO_Contact, name: "ES_PO_Contact" },
                        { GUID: configJsonFile.DPMSGuids.PWC_PO_Holder_VendorCode, sValue: PWC_PO_Holder_VendorCode, name: "PWC_PO_Holder_VendorCode" },
                        { GUID: configJsonFile.DPMSGuids.Request_Requiring_Special_Approval, sValue: Request_requiring_special_approval, name: "Request_requiring_special_approval" },
                        { GUID: configJsonFile.DPMSGuids.Is_this_PN_included_exception_agreemen, sValue: PN_ExceptionVal, name: "PN_Exception_Agreement" },
                        { GUID: configJsonFile.DPMSGuids.Specify, sValue: OtherPNExceptionComments, name: "OtherPNExceptionComments" },
                        { GUID: configJsonFile.DPMSGuids.Applicable_Marking_Spec, sValue: ApplicableMarkingSpec, name: "ApplicableMarkingSpec" },
                        { GUID: configJsonFile.DPMSGuids.Applicable_Marking_Spec_Tech, sValue: ApplicableMarkingSpecTech, name: "ApplicableMarkingSpec tech" },
                        { GUID: configJsonFile.DPMSGuids.Marking_Method, sValue: MarkingMethod, name: "Marking Method" },
                        { GUID: configJsonFile.DPMSGuids.Drawing_Type, sValue: DrawingType, name: "DrawingType" },
                        { GUID: configJsonFile.DPMSGuids.Regulatory_And_Inspection_Marking, sValue: RegulatoryInspection, name: "RegulatoryInspection" },
                        { GUID: configJsonFile.DPMSGuids.For_A_Part_Number, sValue: For_A_PartNumber, name: "For_A_PartNumber" },
                        { GUID: configJsonFile.DPMSGuids.PartRevision, sValue: Part_Revision, name: "Part_Revision" },
                        { GUID: configJsonFile.DPMSGuids.For_A_PN_Familly_add_Sufixes, sValue: For_a_PNFamilyAndSufixes, name: "For_a_PNFamilyAndSufixes" },
                        { GUID: configJsonFile.DPMSGuids.Tracebility_Requirements, sValue: TracebilityRequirement, name: "TracebilityRequirement" },
                        { GUID: configJsonFile.DPMSGuids.Additional_Tracebility, sValue: AdditionalTracebility, name: "AdditionalTracebility" },
                        { GUID: configJsonFile.DPMSGuids.Manufacturing_supplier_Vendor_prefix, sValue: ManufacturingSupplierPrefix, name: "ManufacturingSupplierPrefix" },
                        { GUID: configJsonFile.DPMSGuids.TwoD_Datamatrix_format_requirement, sValue: TwoDDataMatrixRequirment, name: "TwoDDataMatrixRequirment" },
                        { GUID: configJsonFile.DPMSGuids.TwoD_Datamatrix_Encoded_Data, sValue: TwoDDataMatrixEncodedData, name: "TwoDDataMatrixEncodedData" },
                        { GUID: configJsonFile.DPMSGuids.If_other_please_secify, sValue: IfOtherPleaseSecify, name: "IfOtherPleaseSecify" },
                        { GUID: configJsonFile.DPMSGuids.Other_2D_Encoded_Data_when_required_by_drawing, sValue: Other2DEncodedData, name: "Other2DEncodedData" },
                        { GUID: configJsonFile.DPMSGuids.Select_the_label_that_is_appropriate_according_to, sValue: SelectLablePartTraceability, name: "SelectLablePartTraceability" },
                        { GUID: configJsonFile.DPMSGuids.Proposed_Marking_if_necessary_put_comment_in_4_3, sValue: ProposedMarking, name: "ProposedMarking" },
                        { GUID: configJsonFile.DPMSGuids.Other_Drawing1, sValue: Additional_Ident_Markings1ddl, name: "Additional_Ident_Markings1ddl" },
                        { GUID: configJsonFile.DPMSGuids.Supplier_Tracebility, sValue: Additional_Ident_Markings1txt, name: "Additional_Ident_Markings1txt" },
                        { GUID: configJsonFile.DPMSGuids.Other_Drawing2, sValue: Additional_Ident_Markings2ddl, name: "Additional_Ident_Markings2ddl" },
                        { GUID: configJsonFile.DPMSGuids.Supplier_Tracebility2, sValue: Additional_Ident_Markings2txt, name: "Additional_Ident_Markings2txt" },
                        { GUID: configJsonFile.DPMSGuids.Other_Drawing3, sValue: Additional_Ident_Markings3ddl, name: "Additional_Ident_Markings3ddl" },
                        { GUID: configJsonFile.DPMSGuids.Supplier_Tracebility3, sValue: Additional_Ident_Markings3txt, name: "Additional_Ident_Markings3txt" },
                        { GUID: configJsonFile.DPMSGuids.Other_Drawing4, sValue: Additional_Ident_Markings4ddl, name: "Additional_Ident_Markings4ddl" },
                        { GUID: configJsonFile.DPMSGuids.Supplier_Tracebility4, sValue: Additional_Ident_Markings4txt, name: "Additional_Ident_Markings4txt" },
                        { GUID: configJsonFile.DPMSGuids.Comments_Supplier_identification_marking_explanations, sValue: Supplier_Ident_Marking_Explanation, name: "Supplier_Ident_Marking_Explanation" },
                        { GUID: configJsonFile.DPMSGuids.InitiatorEmailAddress, sValue: InitiatorEmailAddress, name: "InitiatorEmailAddress" }
                    ],
                    GeneralInformation: [],
                    GeneralInformationListGuids: {
                        PartNumberGuid: "",
                        ReasonForScrapGuid: "",
                        QuantityGuid: "",
                        PO_SA_NumberGuid: "",
                        QN_RFA_NumberGuid: "",
                        SerialNumberGuid: "",
                        generalInfoItemListGuid: ""
                    }
                };
                //alert(dictstring);
                console.log(dictstring);
                CallWebAPI(dictstring, resTokenApiVal);

                // Update Session variable to get increment num
                localStorage.setItem("DPMSProcessID", newProcessIDNum);
                // Call API End 
            }
        } else {
            alert("Please fill the all required fields (or) Enter valid email address..!");
            event.preventDefault();
        }
        }else{
            alert("'2D Datamatrix encoded data' field is required. Please fill a value to proceed further!");
            event.preventDefault();
        }
    }

    const formValidation = () => {
        var isFormValid = true;
        if (RequestType === "0#-- Select --" || Request_requiring_special_approval === "0#-- Select --" || ApplicableMarkingSpec === "0#-- Select --" || MarkingMethod === "0#-- Select --" || DrawingType === "0#-- Select --" || RegulatoryInspection === "0#-- Select --" || TracebilityRequirement === "0#-- Select --" || AdditionalTracebility === "0#-- Select --" || TwoDDataMatrixRequirment === "0#-- Select --" || SelectLablePartTraceability === "0#-- Select --") {
            isFormValid = false;
        }
        if (RequestType === "" || Request_requiring_special_approval === "" || ApplicableMarkingSpec === "" || MarkingMethod === "" || DrawingType === "" || RegulatoryInspection === "" || TracebilityRequirement === "" || AdditionalTracebility === "" || TwoDDataMatrixRequirment === "" || SelectLablePartTraceability === "") {
            isFormValid = false;
        }
        return isFormValid;
    }
    const formEmailValidation = () => {
        var isFormEmailsValid = false;
        if (validator.isEmail(VendorEmail)) {
            isFormEmailsValid = true;
        }
        return isFormEmailsValid;
    }
    // Call API to upload files to S3
    const CallWebAPI = async (requestBody, getTokeVal) => {
        try {
            console.log("Attempting to API call to create/update instance..!");
            const parsedUrl = new URL(configJsonFile.Server_Webcon_Creation_APIUrl);
            if (!isValidDomain(parsedUrl.hostname)) {
                throw new Error('Invalid domain');
            }
            const axiosInstance = axios.create({
                    baseURL: configJsonFile.ServerAPIUrl,
                    allowAbsoluteUrls: false
                    });
            //configJsonFile.ServerAPIUrl
            axios.post(parsedUrl, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-id': configJsonFile.ClientId,
                    'Authorization': "Bearer " + getTokeVal,
                    'RequestVerificationToken': csrfToken.current
                }
            }).then(res => {
                if (res.status === 201 || res.status === 200 || res.status === 202) {
                    var elementID = res.data;
                    if (selectedFile.length > 0) {
                        for (let i = 0; i < selectedFile.length; i++) {
                            // upload each file to S3 calling API here
                            let Num = i + 1;
                            CallWebAPIUploadFileToS3(selectedFile[i], Num, getTokeVal, elementID);
                        }
                    }
                    else{
                        setLoading(false);
                        setmodelPopupshow(true);          
                        setApiErrormessage("");
                      }
                    //setAPIMessage("Files are uploaded successfully to AWS S3");
                } else {
                    console.log("Status Code:" + res.status);
                    console.log("Status Data:" + res.data);
                }
            }).catch(error => {
                if (error.response) {
                    console.log('Error response:', error.response.data);
                    setLoading(false);
                    setApiErrormessage(error.response.data || 'An error occurred');                    
                    if (error.response.data.includes('Vendor Code')) {
                        setInvalidVendorCode("Invalid");
                        setApiErrormessage("Vendor Code '" + VendorCode + "' does not exist, Please enter correct value and submit again.")
                    } else {
                        setInvalidVendorCode("");
                    };
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }
            });
            console.log("... Attempt completed!");
        } catch (err) {
            console.log(err);
            console.log("Error Json:" + err.toJSON());
            setAPIMessage("Failed Due to:" + err);
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

    }

    const CallWebAPIUploadFileToS3 = async (requestBody, num, getTokeVal, elementID) => {
        try {
            let fileNameVal = elementID + "_" + num + "-" + requestBody.name;
            console.log("FileName: " + fileNameVal);
            const formData = new FormData();
            formData.append('file', requestBody);
            formData.append('fileName', fileNameVal);
            formData.append('processID', "");
            formData.append('cookie', cookieToken.current);

            axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-api-id': configJsonFile.ClientId,
                    'Authorization': "Bearer " + getTokeVal
                }
            }).then(res => {
                if (res.status === 201 || res.status === 200 || res.status === 202) {
                    setLoading(false);
                    setmodelPopupshow(true);
                    setAPIMessage("Files are uploaded successfully to AWS S3");
                } else {
                    console.log("Status Code:" + res.status);
                }
            });

        } catch (err) {
            setLoading(false);
            setApiErrormessage(err.response.data || 'An error occurred');
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

    }

    const isValidDomain = (domain) => {
        const allowedDomains = ['apid.pwc.ca', 'apiq-ext.pwc.ca', 'api-ext.pwc.ca'];
        return allowedDomains.includes(domain);
    };

    const onClickHomeHandler = async (event) => {
        const isConfirmedHome = window.confirm('You might loose the data, Are you sure you want to go to home page?');
        if (isConfirmedHome) {
            navigate('/');
        }
    }
    const onClickCancelHandler = async (event) => {
        const isConfirmedCancel = window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
        if (isConfirmedCancel) {
            navigate('/');
        }

    }

    const handleOkButtonModelPopup = () => {
        navigate('/');
        setmodelPopupshow(false);
    }

    const handleChangeConfirmCheckbox = () => {
        setIsConfirmChecked(!isConfirmChecked);
    }

    const handlePNExceptionChange = (event) => {
        setPN_Exception_Agreement(event.target.checked);
        if (event.target.checked) {
            setShowPNExceptionCommentsText(true);
        } else {
            setShowPNExceptionCommentsText(false);
        }

    }

    const handleChangeSelectPartTraceability = (event) => {
        setSelectLablePartTraceability(event.target.value);
        if (event.target.value === "1#A) SER NO. (SER only or with 2D CPW920-1)") {
            setShowSection3_A_Image(true);
            setShowSection3_B_Image(false);
            setShowSection3_C_Image(false);
            setShowSection3_D_Image(false);
            setShowSection3_E_Image(false);
            setShowSection3_F_Image(false);
        }
        if (event.target.value === "2#B) USN NO. (SER + 2D other formats)") {
            setShowSection3_A_Image(false);
            setShowSection3_B_Image(true);
            setShowSection3_C_Image(false);
            setShowSection3_D_Image(false);
            setShowSection3_E_Image(false);
            setShowSection3_F_Image(false);
        }
        if (event.target.value === "3#C) UI NO. (UI only or with 2D CPW920-1)") {
            setShowSection3_A_Image(false);
            setShowSection3_B_Image(false);
            setShowSection3_C_Image(true);
            setShowSection3_D_Image(false);
            setShowSection3_E_Image(false);
            setShowSection3_F_Image(false);
        }
        if (event.target.value === "4#D) UI NO. (UI + 2D other formats)") {
            setShowSection3_A_Image(false);
            setShowSection3_B_Image(false);
            setShowSection3_C_Image(false);
            setShowSection3_D_Image(true);
            setShowSection3_E_Image(false);
            setShowSection3_F_Image(false);
        }
        if (event.target.value === "5#E) LOT (No traceability requirement)") {
            setShowSection3_A_Image(false);
            setShowSection3_B_Image(false);
            setShowSection3_C_Image(false);
            setShowSection3_D_Image(false);
            setShowSection3_E_Image(true);
            setShowSection3_F_Image(false);
        } if (event.target.value === "6#F) Not applicable") {
            setShowSection3_A_Image(false);
            setShowSection3_B_Image(false);
            setShowSection3_C_Image(false);
            setShowSection3_D_Image(false);
            setShowSection3_E_Image(false);
            setShowSection3_F_Image(true);
        } if (event.target.value === "0#-- Select --") {
            setShowSection3_A_Image(false);
            setShowSection3_B_Image(false);
            setShowSection3_C_Image(false);
            setShowSection3_D_Image(false);
            setShowSection3_E_Image(false);
            setShowSection3_F_Image(false);
        }

    }

    const handleAdditionaDrpdown1 = (event) => {
        setAdditional_Ident_Markings1ddl(event.target.value);
        if (event.target.value !== "0#-- Select --") {
            setAdditionalTxt_Required_1(true);
        } else {
            setAdditionalTxt_Required_1(false);
        }
    }
    const handleAdditionaDrpdown2 = (event) => {
        setAdditional_Ident_Markings2ddl(event.target.value);
        if (event.target.value !== "0#-- Select --") {
            setAdditionalTxt_Required_2(true);
        } else {
            setAdditionalTxt_Required_2(false);
        }
    }
    const handleAdditionaDrpdown3 = (event) => {
        setAdditional_Ident_Markings3ddl(event.target.value);
        if (event.target.value !== "0#-- Select --") {
            setAdditionalTxt_Required_3(true);
        } else {
            setAdditionalTxt_Required_3(false);
        }
    }
    const handleAdditionaDrpdown4 = (event) => {
        setAdditional_Ident_Markings4ddl(event.target.value);
        if (event.target.value !== "0#-- Select --") {
            setAdditionalTxt_Required_4(true);
        } else {
            setAdditionalTxt_Required_4(false);
        }
    }

    const validateInitiatorEmail = (e) => {
        const email = e.target.value;
        if (validator.isEmail(email)) {
            setInitiatorEmailAddress(e.target.value);
            setInitiatorEmailError("");
        } else {
            setInitiatorEmailAddress(e.target.value);
            setInitiatorEmailError("Please Enter valid Email");
        }
    }
    const validateVendorEmail = (e) => {
        const vEmail = e.target.value;
        if (validator.isEmail(vEmail)) {
            setVendorEmail(e.target.value)
            setVendorEmailError("");
        } else {
            setVendorEmail(e.target.value)
            setVendorEmailError("Please Enter valid Email");
        }
    }
    const handleApplicableMarkingChange = (e) => {
        const selectedCategory = e.target.value;
        setApplicableMarkingSpec(selectedCategory);
        setMarkingMethod('');
        setMarkingDropdownOptions(MarkingDrpoptions[selectedCategory] || []);
        setApplicableMarkingSpecTech(ApplicableMarkingTechValues[selectedCategory] || "");
    }
    const handleChange2DDataMatrixRequirment=(e)=>{
        setTwoDDataMatrixRequirment(e.target.value);
        var element2DRequired = document.getElementById("2DDataMatrixRequired");
        if(e.target.value =="1#No 2D data matrix required by drawing"){        
            document.getElementById("2DMatrixEncodedData").style.display = 'none';
             element2DRequired.required = false;
        }else{
            document.getElementById("2DMatrixEncodedData").style.display = 'block';
            element2DRequired.required = true;
        }
    }

    if (auth && auth.userData) {
        return (
            <form onSubmit={handleSubmit}>
                <div class="container">
                    <div class="row">
                        <div class="col-8 p-0">
                            <img src={imgLogo} alt="Logo" width="100%" height="80%" />
                        </div>
                        <div class="col-4 p-0">
                            <img src={rightLogo} alt="Logo" width="100%" height="80%" />
                        </div>
                    </div>
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Vendor Information</h5></div></div>
                    <div class="marginLeft" Id="InitialFields">
                        <div class="row"><label style={{ color: 'red' }}>{apiErrormessage}</label> </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="InitiatorEmailAddress">Initiator User ID<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={InitiatorEmailAddress}
                                    onChange={(e) => setInitiatorEmailAddress(e.target.value)}
                                    placeholder="Enter Initiator User ID" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="vendorCode">Vendor Code<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="number"
                                    value={VendorCode}
                                    onChange={(e) => setVendorCode(e.target.value)}
                                    placeholder="Enter Vendor code" required style={{ borderColor: invalidVendorCode ? 'red' : '' }} />
                            </div>
                            <div class="col-2">
                                <label for="vendorName">Vendor Name<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={VendorName}
                                    onChange={(e) => setVendorName(e.target.value)}
                                    placeholder="Enter Vendor Name" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="vendorEmail">Vendor Email<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={VendorEmail}
                                    onChange={(e) => validateVendorEmail(e)}
                                    placeholder="Enter Vendor email" required />
                                <div style={{ color: 'red' }}>{vendorEmailError}</div>
                            </div>
                            <div class="col-2" style={{ width: '17%' }}>
                                <label for="VendorContactName">Vendor Contact Name<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4" style={{ width: '33%', paddingLeft: '6px' }}>
                                <input type="text"
                                    value={VendorContactName}
                                    onChange={(e) => setVendorContactName(e.target.value)}
                                    placeholder="Enter Vendor Contact Name" required />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2">
                                <label for="Telephone">Telephone<label style={{ color: 'red' }}>*</label></label>
                            </div>
                            <div class="col-4">
                                <input type="number"
                                    value={Telephone}
                                    onChange={(e) => setTelephone(e.target.value)}
                                    placeholder="Enter Phone Number" required />
                            </div>
                            <div class="col-2">
                                <label for="Date">Date</label>
                            </div>
                            <div class="col-4">
                                <input type="Date"
                                    value={DateValue}
                                    onChange={(e) => setDateValue(e.target.value)}
                                    placeholder="Enter Date" required readOnly style={{ backgroundColor: '#e9ecefe3' }} />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="SupplierComments1">Supplier Comments</label>
                            </div>
                            <div class="col-10">
                                <textarea class="VendorComments" id="Comments" name="Comments" value={SupplierComments1} placeholder="Enter Supplier Comments" onChange={(e) => setSupplierComments1(e.target.value)} ></textarea>
                            </div>
                        </div>
                    </div>

                    {/*Section 0 - General information */}
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section 0 - General Information</h5></div></div>
                    <div class="marginLeft" Id="InitialFields">
                        <div class="row">
                            <div class="col-2">
                                <label for="requestType">1) Request Type <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="requestType" name="Request Type" value={RequestType} onChange={(e) => setRequestType(e.target.value)} required>
                                    {RequestTypeDropDownVals}
                                </select>
                            </div>
                            <div class="col-2">
                                <label for="ES_PO_Contact">2) ES#/PO#/Contact <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={ES_PO_Contact}
                                    onChange={(e) => setES_PO_Contact(e.target.value)}
                                    placeholder="Enter ES#/PO#/Contact" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="POHolderVendorCode">3) P&WC PO holder Vendor Code</label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={PWC_PO_Holder_VendorCode}
                                    onChange={(e) => setPWC_PO_Holder_VendorCode(e.target.value)}
                                    placeholder="Enter Vendor Code" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label for="requestRequire">4) Is this Request requiring special approval(e.g. MSC, prefix, etx.)? <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-5">
                                <select id="requestRequireType" name="Request require Type" value={Request_requiring_special_approval} onChange={(e) => setRequest_requiring_special_approval(e.target.value)} required>
                                    {RequestReqAppDropDownVals}
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-10">
                                <label>5) Is this PN to be included in an exception agreement(e.g. Quality Plan, dispensation, etc.)?</label>&nbsp;&nbsp; <input type="checkbox" value={PN_Exception_Agreement} onChange={handlePNExceptionChange} />
                            </div>
                            {showPNExceptionCommentsText ? <div className="row">
                                <div class="col-2"><label for="Specify">Specify<p style={{ color: "red", float: "right" }}>*</p></label></div>
                                <div className="col-10">
                                    <input type="text" id="OtherPNExceptionComments" value={OtherPNExceptionComments} onChange={(e) => setOtherPNExceptionComments(e.target.value)} placeholder="If Question5 is True, then specify in this field" required={showPNExceptionCommentsText} />
                                </div></div> : ""}
                        </div>
                    </div>

                    {/* Section 1 - MARKING AND TRACEABILITY REQUIREMENTS */}
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section 1 - Marking And Traceability Requirements</h5></div></div>
                    <div class="marginLeft" Id="InitialFields">
                        <div class="row">
                            <div class="col-2">
                                <label for="ApplicableMarkingSpec">1) Applicable marking spec: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="ApplicableMarkingSpec" name="ApplicableMarkingSpec" value={ApplicableMarkingSpec} onChange={handleApplicableMarkingChange} required>
                                    {ApplicableMarkingSpecDropDownVals}
                                </select>
                            </div>
                            <div class="col-2">
                                <label for="MarkingMethod">2) Marking method: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="MarkingMethod" name="MarkingMethod" value={MarkingMethod} onChange={(e) => setMarkingMethod(e.target.value)} required disabled={!ApplicableMarkingSpec}>
                                    <option value="">-- Select --</option>
                                    {MarkingDropdownOptions.map((option, index) => (
                                        <option key={index} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="DrawingType">3) Drawing Type: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="DrawingType" name="DrawingType" value={DrawingType} onChange={(e) => setDrawingType(e.target.value)} required>
                                    {DrawingTypeDropDownVals}
                                </select>
                            </div>
                            <div class="col-2">
                                <label for=" Regulatory&InspectionMarking">4) Regulatory and Inspection marking: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="RegulatoryInspectionMarking" name="RegulatoryInspectionMarking" value={RegulatoryInspection} onChange={(e) => setRegulatoryInspection(e.target.value)} required>
                                    {RegulatoryInspectionMarkingDropDownVals}
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="For_a_Part_Number">5) For a Part number: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={For_A_PartNumber}
                                    onChange={(e) => setFor_A_PartNumber(e.target.value)}
                                    placeholder="Enter Part Number" required />
                            </div>
                            <div class="col-2">
                                <label for="PartRevision">6) Part Revision: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={Part_Revision}
                                    onChange={(e) => setPart_Revision(e.target.value)}
                                    placeholder="Enter Part Revision" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="">7) For a PN Familly add sufixes</label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={For_a_PNFamilyAndSufixes}
                                    onChange={(e) => setFor_a_PNFamilyAndSufixes(e.target.value)}
                                    placeholder="Enter PN Family" />
                            </div>
                            <div class="col-2">
                                <label for="TracebilityRequirements">8) Tracebility Requirements (as per drawing): <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="TracebilityRequirements" name="TracebilityRequirements" value={TracebilityRequirement} onChange={(e) => setTracebilityRequirement(e.target.value)} required>
                                    {TracebilityRequirementsDropDownVals}
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="AdditionalTracebility">9) Additional tracebility: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="AdditionalTracebility" name="AdditionalTracebility" value={AdditionalTracebility} onChange={(e) => setAdditionalTracebility(e.target.value)} required>
                                    {AdditionalTracebilityDropDownVals}
                                </select>
                            </div>
                            <div class="col-2">
                                <label for="">10) Manufacturing supplier (Vendor) prefix: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={ManufacturingSupplierPrefix}
                                    onChange={(e) => setManufacturingSupplierPrefix(e.target.value)}
                                    placeholder="Enter Manufacturing supplier perfix" required />
                            </div>
                        </div>
                    </div>

                    {/* Section 2 - 2D DATAMATRIX */}
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section 2 - 2D Datamatrix</h5></div></div>
                    <div class="marginLeft" Id="InitialFields">
                        <div class="row">
                            <div class="col-2">
                                <label for="">1) 2D datamatrix format requirement: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="DrawingType" name="DrawingType" value={TwoDDataMatrixRequirment} onChange={handleChange2DDataMatrixRequirment} required>
                                    {TwoDDataMatrixRequirmentDropDownVals}
                                </select>
                            </div>
                            <div class="col-2">
                                <label for="">2) 2D Datamatrix encoded data: <p id="2DMatrixEncodedData" style={{ color: "red", float: "right", display:'none' }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={TwoDDataMatrixEncodedData}
                                    onChange={(e) => setTwoDDataMatrixEncodedData(e.target.value)}
                                    placeholder="" id="2DDataMatrixRequired" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <label for="">3) If other, please secify:</label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={IfOtherPleaseSecify}
                                    onChange={(e) => setIfOtherPleaseSecify(e.target.value)}
                                    placeholder="" />
                            </div>
                            <div class="col-2">
                                <label for="">4) Other 2D encoded data when required by drawing:</label>
                            </div>
                            <div class="col-4">
                                <input type="text"
                                    value={Other2DEncodedData}
                                    onChange={(e) => setOther2DEncodedData(e.target.value)}
                                    placeholder="" />
                            </div>
                        </div>

                    </div>

                    {/* Section 3 - CPW40 internal bar code Packaging label */}
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section 3 - CPW40 Internal Bar Code Packaging Label</h5></div></div>
                    <div class="marginLeft" Id="InitialFields">
                        <div class="row">
                            <div class="col-7">
                                <label for="">1) Select the label that is appropriate according to the part traceability: <p style={{ color: "red", float: "right" }}>*</p></label>
                            </div>
                            <div class="col-4">
                                <select id="" name="SelectLAblePArtTraceability" value={SelectLablePartTraceability} onChange={handleChangeSelectPartTraceability} required>
                                    {SelectLablePartTraceabilityDropDownVals}
                                </select>
                            </div>
                        </div>

                        {/* Section 3 - Images Should add Here.. will add later based on Rule */}
                        <div class="row">
                            {ShowSection3_A_Image ? <div class="col-5"><img src={AImage} alt="A-Logo" width="100%" height="100%" /></div> : ""}
                            {ShowSection3_B_Image ? <div class="col-5"><img src={BImage} alt="B-Logo" width="100%" height="100%" /></div> : ""}
                            {ShowSection3_C_Image ? <div class="col-5"><img src={CImage} alt="C-Logo" width="100%" height="100%" /></div> : ""}
                            {ShowSection3_D_Image ? <div class="col-5"><img src={DImage} alt="D-Logo" width="100%" height="100%" /></div> : ""}
                            {ShowSection3_E_Image ? <div class="col-5"><img src={EImage} alt="E-Logo" width="100%" height="100%" /></div> : ""}
                            {ShowSection3_F_Image ? <div class="col-5"><img src={FImage} alt="F-Logo" width="100%" height="100%" /></div> : ""}
                        </div>
                    </div>

                    {/* Section 4 - HUMAN READABLE MARKING */}
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section 4 - Human Readable Marking</h5></div></div>
                    <div class="marginLeft" Id="InitialFields">
                        <div class="row">
                            <label for="Proposed">1) Proposed Marking (if necessary put comment in 4-3) <p style={{ color: "red", float: "left" }}>*</p></label>
                        </div>
                        <div class='row'>
                            <textarea class="VendorComments" id="ProposedMarking" name="ProposedMarking" value={ProposedMarking} placeholder="" onChange={(e) => setProposedMarking(e.target.value)} ></textarea>
                        </div>
                        <div class="row">
                            <label for="Additional">2) Additional Identification Markings (if applicable):</label>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <select id="" name="" value={Additional_Ident_Markings1ddl} onChange={handleAdditionaDrpdown1} >
                                    {Additional_Ident_MarkingsddlDropDownVals}
                                </select>
                            </div>
                            <div class="col-6">
                                <input type="text"
                                    value={Additional_Ident_Markings1txt}
                                    onChange={(e) => setAdditional_Ident_Markings1txt(e.target.value)}
                                    placeholder="" required={AdditionalTxt_Required_1} />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <select id="" name="" value={Additional_Ident_Markings2ddl} onChange={handleAdditionaDrpdown2} >
                                    {Additional_Ident_MarkingsddlDropDownVals_2}
                                </select>
                            </div>
                            <div class="col-6">
                                <input type="text"
                                    value={Additional_Ident_Markings2txt}
                                    onChange={(e) => setAdditional_Ident_Markings2txt(e.target.value)}
                                    placeholder="" required={AdditionalTxt_Required_2} />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <select id="" name="" value={Additional_Ident_Markings3ddl} onChange={handleAdditionaDrpdown3} >
                                    {Additional_Ident_MarkingsddlDropDownVals_3}
                                </select>
                            </div>
                            <div class="col-6">
                                <input type="text"
                                    value={Additional_Ident_Markings3txt}
                                    onChange={(e) => setAdditional_Ident_Markings3txt(e.target.value)}
                                    placeholder="" required={AdditionalTxt_Required_3} />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <select id="" name="" value={Additional_Ident_Markings4ddl} onChange={handleAdditionaDrpdown4} >
                                    {Additional_Ident_MarkingsddlDropDownVals_4}
                                </select>
                            </div>
                            <div class="col-6">
                                <input type="text"
                                    value={Additional_Ident_Markings4txt}
                                    onChange={(e) => setAdditional_Ident_Markings4txt(e.target.value)}
                                    placeholder="" required={AdditionalTxt_Required_4} />
                            </div>
                        </div>
                        <div class="row">
                            <label for="Comments">3) Comments/ Supplier identification marking explanations:</label>
                        </div>
                        <div class='row'>
                            <textarea class="VendorComments" id="Supplier_Ident_Marking_Explanation" name="" value={Supplier_Ident_Marking_Explanation} placeholder="" onChange={(e) => setSupplier_Ident_Marking_Explanation(e.target.value)} ></textarea>
                        </div>
                    </div>

                    {/* Section 5 - Attachments */}
                    <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section 5 - Attachments</h5></div></div>
                    <div class="row">
                        <div class="col-2">
                            <label for="subject">Attachments</label>
                        </div>
                        <div class="col-10">
                            <input type="file" onChange={(e) => setSelectedFile(e.target.files ? e.target.files : null)} multiple />
                        </div>
                    </div>


                    <div class="row">
                        <div>
                            <input type="checkbox" value={isConfirmChecked} style={{ color: 'red' }} onChange={handleChangeConfirmCheckbox} required />&nbsp;&nbsp; <label style={{ color: 'red' }}>I confirm this form and attached document(s) DO NOT contain any technical information subject to EAR, ITAR or ECL</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <input type="submit" value="Submit" /> &nbsp;
                            <input type="button" value="Home" onClick={onClickHomeHandler} /> &nbsp;
                            <input type="button" value="Cancel" onClick={onClickCancelHandler} />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-10 text-success">
                            <Modal
                                show={modelPopupshow}
                                onHide={handleOkButtonModelPopup}
                                backdrop="static"
                                keyboard={false}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                                    <Modal.Title> Marking & Traceability Approval Request</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p> Your Marking & Traceability Approval request has been submitted.</p>
                                    <p> You will receive an email with the request information and details for tracking purposes.</p>
                                    <p> Please reach out to your buyer in case of any issues or concerns regarding your request.</p>
                                    <p> Click <strong><mark>OK</mark></strong> to return to the home page.</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleOkButtonModelPopup}>
                                        OK
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal
                                show={loading}
                                onHide={handleOkButtonModelPopup}
                                backdrop="static"
                                keyboard={false}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                                    <Modal.Title> Request in-progress, please wait...</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Loading....</p>
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </div>
            </form>
        )
    } else {
        return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
    }
}

export default NewMarkingApprovalForm;
